// useRfxMail.ts
import { RfxMail } from "components/email-template/types/RfxMail";
import { useCurrentCompany } from "hooks/auth";
import * as React from "react";

import type { Rfx } from "newui/features/Rfx/types/rfx.types";

export function useRfxMail(rfqDetail: Rfx | null) {
	const [additionalMessage, setAdditionalMessage] = React.useState("");
	const [currentCompanyName, setCurrentCompanyName] = React.useState("");
	const [rfxMail, setRfxMail] = React.useState<RfxMail | null>(null);

	const currentCompany = useCurrentCompany();

	const handleSupplierNameChange = (e: { label: string }) => {
		setCurrentCompanyName(e.label);
	};

	const handleAdditionalMessageChange = (value: string) => {
		setAdditionalMessage(value);
	};

	React.useEffect(() => {
		if (!rfqDetail || !currentCompany) {
			return;
		}

		const newMail = new RfxMail(
			rfqDetail,
			currentCompany,
			currentCompanyName,
			additionalMessage
		);
		setRfxMail(newMail);
	}, [rfqDetail, currentCompany, currentCompanyName, additionalMessage]);

	return {
		rfxMail,
		additionalMessage,
		currentCompanyName,
		handleSupplierNameChange,
		handleAdditionalMessageChange,
	};
}
